<template>
	<div class="informationIndex">
		<div>
			<div class="channel-item" v-for="(item,index) in channelList" :key="index" @click="skipDetails(item)">
				<img :src="item.image" alt="">
			</div>			
		</div>
	</div>
</template>
<script>
	import {InformationChannels} from "../../config/interface.js";
	export default{
		data(){
			return{
				channelList:[],     //频道列表
			}
		},
		mounted(){
			this.getChannels();
		},
		methods:{
			//资讯频道
			getChannels(){
				const url=InformationChannels;
				let params={};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.channelList=data;
					}
				})
			},
			//跳转到详情
			skipDetails(item){
				this.$router.push({
					path:'/information/details',
					query:{
						id:item.id,
						name:item.name
					}
				})
			}
		}
	}
</script>
<style lang="scss">
	.informationIndex{
		width:100%;
		height:100%;
		background: #F1F2F4;
		padding:14px 12px;
		>div{
			@include flex(row);
			justify-content:space-between;
			flex-wrap: wrap;
		}
		.channel-item{
			font-size: 15px;
			color: #090909;
			width:48%;
			text-align:center;
			height:93px;
			line-height:93px;
			background:#fff;
			margin-bottom:12px;
			img{
				width:100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/information/Index.vue